import { render, staticRenderFns } from "./EqifyAvatarAndText.vue?vue&type=template&id=bbb7c102&scoped=true"
import script from "./EqifyAvatarAndText.vue?vue&type=script&lang=ts"
export * from "./EqifyAvatarAndText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb7c102",
  null
  
)

export default component.exports